import {Component, Element, State, h, Prop} from '@stencil/core';


@Component({
  tag: 'uiaas-search-widget-cta-product-selector-v2',
  styleUrl: 'product-selector.scss',
  assetsDirs: ['assets/assets-cta-ps'],
  shadow: true
})
export class WidgetCtaProductSelectorv2 {

  @Prop() readonly country: string = 'us';
  @Prop() readonly language: string = 'en';
  @Prop() readonly link: string;
  @Prop() readonly appName: string;
  @Prop() readonly anchorTarget: string = '';
  @Prop() readonly dashboardTabName: string;

  @Element()
    el: HTMLElement;

  @State()
    tabName: string;

  private makeLabel() {
      const language = this.language.toLowerCase();

      switch (language) {
      default:
      case 'en':
        return ['Product Selector', 'Effortlessly discover the products and accessories tailored for your applications.', 'Use Product Selector'];
      case 'de':
        return ['Produktauswahl', 'Entdecken Sie mühelos die Produkte und Zubehörteile, die auf Ihre Anwendungen zugeschnitten sind.', 'Produktauswahl verwenden'];
      case 'pl':
        return ['Selektor produktów', 'Odkryj produkty i akcesoria dopasowane do Twoich zastosowań.', 'Użyj selektora produktów'];
      case 'fr':
        return ['Sélecteur de produits', 'Découvrez sans effort les produits et accessoires adaptés à vos applications.', 'Utiliser le sélecteur de produits'];
      case 'ru':
        return ['Система подбора продукции', 'Легкое обнаружение продуктов и аксессуаров, предназначенных для ваших приложений.', 'Использовать инструмент подбора продуктов'];
      case 'nl':
        return ['Productselector', 'Ontdek moeiteloos de producten en accessoires die speciaal ontwikkeld werden voor uw toepassingen.', 'Productkiezer gebruiken'];
      case 'it':
        return ['Selettore prodotto', 'Scopri i prodotti e gli accessori personalizzati per le tue applicazioni.', 'Utilizza Selettore prodotto'];
      case 'sv':
        return ['Produktväljare', 'Upptäck produkter och tillbehör som är skräddarsydda för dina tillämpningar.', 'Använd produktväljare'];
      case 'es':
        return ['Selector de productos', 'Descubre sin esfuerzo los productos y accesorios adaptados a tus aplicaciones.', 'Utilizar selector de productos'];
      case 'ja':
        return ['製品セレクター', 'お客様の用途に合わせてカスタマイズされた製品とアクセサリーを簡単に見つけることができます。', '製品セレクターを使用'];
      case 'zh':
        return ['产品选型工具', '轻松了解为您的应用量身定制的产品和配件。', '即刻了解'];
      case 'fi':
        return ['Tuotevalitsin', 'Löydä helposti käyttökohteeseesi räätälöidyt tuotteet ja lisävarusteet.', 'Käytä tuotevalitsinta'];
      case 'bg':
        return ['Избор на продукт', 'Без усилие открийте продуктите и аксесоарите, специално пригодени за вашите приложения.', 'Използване на избор на продукт'];
      case 'pt':
        return ['Seletor de produtos', 'Descubra facilmente os produtos e acessórios sob medida para suas aplicações.', 'Usar Seletor de Produtos'];
      case 'cs':
        return ['Nástroj pro výběr produktů', 'Objevte produkty a příslušenství přizpůsobené pro vaše aplikace.', 'Použít nástroj pro výběr produktů'];
      case 'da':
        return ['Produktvælger', 'Opdag nemt de produkter og det tilbehør, der er skræddersyet til dine opgaver.', 'Brug produktvælger'];
      case 'et':
        return ['Vali toode', 'Leidke endale sobilikke tooteid ja tarvikuid.', 'Kasuta tootevalijat'];
      case 'ar':
        return ['أداة تحديد المنتجات', 'اكتشف المنتجات والملحقات المخصصة لتطبيقاتك دون عناء.', 'إستخدام أداة تحديد المنتجات'];
      case 'el':
        return ['Επιλογέας προϊόντος', 'Ανακαλύψτε εύκολα τα προϊόντα και τα εξαρτήματα που είναι προσαρμοσμένα στις εφαρμογές σας.', 'Χρήση εργαλείου επιλογής προϊόντος'];
      case 'hr':
        return ['Alat za odabir proizvoda', 'Jednostavno otkrij proizvode i dodatnu opremu prilagođenu tvojim primjenama.', 'Upotrijebi alat za odabir proizvoda'];
      case 'hu':
        return ['Termékválasztó', 'Fedezze fel az alkalmazásaira szabott termékeket és tartozékokat!', 'Termékválasztó használata'];
      case 'id':
        return ['Pemilih Produk', 'Temukan produk dan aksesoris yang disesuaikan dengan aplikasi Anda secara efisien.', 'Gunakan Pemilih Produk'];
      case 'he':
        return ['בורר המוצר', 'גלה ללא מאמץ את המוצרים והאביזרים המותאמים עבור היישומים שלך.', 'השתמש בבורר המוצר'];
      case 'ko':
        return ['제품 선택도구', '용도에 맞는 제품과 액세서리를 쉽게 살펴보십시오.', '제품 선택도구 사용'];
      case 'lt':
        return ['Produktų parinkėjas', 'Paprastai atraskite pagal jūsų poreikius pritaikytus produktus ir priedus.', 'Naudoti produktų parinkėją'];
      case 'lv':
        return ['Produktu atlasītājs', 'Viegli atklājiet produktus un piederumus, kas pielāgoti jūsu pielietojumiem.', 'Izmantot produktu atlasītāju'];
      case 'no':
        return ['Produktvelger', 'Oppdag produktene og tilbehøret som er skreddersydd for dine applikasjoner, uten problemer.', 'Bruk produktvelger'];
      case 'ro':
        return ['Selector de produse', 'Descoperiti fara efort produsele si accesoriile adaptate aplicatiilor dvs.', 'Utilizare selector produse'];
      case 'sr':
        return ['Selektor proizvoda', 'Nesmetano otkrij proizvode i dodatnu opremu prilagođenu vašim primenama.', 'Use Product Selector'];
      case 'sl':
        return ['Konfigurator izdelkov', 'Preprosto odkrij izdelke in dodatke, prilagojene svojim aplikacijam.', 'Uporabi konfigurator izdelkov'];
      case 'sk':
        return ['Výber produktov', 'Jednoducho objavte produkty a príslušenstvo prispôsobené pre vaše aplikácie.', 'Použiť výber produktov'];
      case 'th':
        return ['ตัวเลือกผลิตภัณฑ์', 'ค้นพบผลิตภัณฑ์และอุปกรณ์เสริมที่ปรับแต่งสำหรับแอปพลิเคชันของคุณได้อย่างง่ายดาย', 'ใช้ตัวเลือกผลิตภัณฑ์'];
      case 'tr':
        return ['Ürün Seçici', 'Uygulamalarınız için uyarlanmış ürünleri ve aksesuarları kolayca keşfedin.', 'Ürün Seçiciyi Kullan'];
      case 'uk':
        return ['Селектор продуктів', 'Легко ознайомтеся з продуктами та аксесуарами, адаптованими до ваших потреб.', 'Скористатися Селектором Продуктів'];
      case 'vi':
        return ['Công cụ chọn Sản phẩm', 'Dễ dàng khám phá các sản phẩm và phụ kiện được thiết kế riêng cho ứng dụng của bạn.', 'Dùng công cụ chọn sản phẩm'];
      }
  }

  private makeLink() {
      if (this.link)
        return this.link;

      const country = this.country.toLowerCase();
      const language = this.language.toLowerCase();
      let productSelectorLink = `https://www.se.com/${country}/${language}/work/support/product-selector/`;
      productSelectorLink = country == 'us' || country == 'ca' ?
        `https://www.se.com/${country}/${language}/work/support/resources-and-tools/calculators-and-online-tools/ez-selectors/` :
        country == 'cn' && language == 'zh' ?
          'https://www.schneider-electric.cn/zh/work/support/product-selector/' : productSelectorLink;

      return productSelectorLink;
  }

  connectedCallback() {
      const closestTabEl = this.el.closest('uiaas-search-tab');
      this.tabName = closestTabEl?.['tabName'] || this.dashboardTabName;
  }

  render() {
      const labels = this.makeLabel();
      const link = this.makeLink();
      return <uiaas-search-cta-widget-v2
        anchor-target={this.anchorTarget}
        tab-name= {this.tabName}
        event-category= "Product selector"
        header={labels[0]}
        content={labels[1]}
        url={link}
        buttonText={labels[2]}
      >
        <qds-icon
          slot="icon"
          size="large" 
          name="squares-checked"
          className="dashboard-widget-icon"
        />
      </uiaas-search-cta-widget-v2>;
  }
}
